"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.warnonce = warnonce;
let warns = [];
function warnonce(msg, key = msg) {
  if (!warns.includes(key)) {
    console.warn(msg);
    warns.push(key);
  }
}